import React from 'react';
import { TextField } from './components';

// Simplified content item interface
export interface ContentItem {
  id: string;
  type: string;
  content: string;
  metadata?: Record<string, any>;
}

// Simplified document data structure
export interface SimplifiedDocumentData {
  content: ContentItem[];
  lastSaved?: string;
  widgetData?: Record<string, any>;
}

interface ContentBlockWrapperProps {
  item: ContentItem;
  isActive?: boolean;
  onUpdate: (id: string, content: string) => void;
  onDelete: (id: string) => void;
  onFocus: (id: string) => void;
  onEnter: (id: string) => void;
  onBackspace: (id: string) => void;
  onArrowUp: (id: string) => void;
  onArrowDown: (id: string) => void;
  onCommand: (id: string, command: string) => void;
  className?: string;
}

export const ContentBlockWrapper: React.FC<ContentBlockWrapperProps> = ({
  item,
  isActive = false,
  onUpdate,
  onDelete,
  onFocus,
  onEnter,
  onBackspace,
  onArrowUp,
  onArrowDown,
  onCommand,
  className
}) => {
  // Map content types to their respective components
  const renderContent = () => {
    switch (item.type) {
      case 'text':
        return (
          <TextField
            id={item.id}
            content={item.content}
            isActive={isActive}
            onUpdate={onUpdate}
            onDelete={onDelete}
            onFocus={onFocus}
            onEnter={onEnter}
            onBackspace={onBackspace}
            onArrowUp={onArrowUp}
            onArrowDown={onArrowDown}
            onCommand={onCommand}
            className={className}
          />
        );
      
      // Add more content types here as needed
      // case 'image':
      //   return <ImageField ... />;
      // case 'document-blueprint':
      //   return <DocumentBlueprintField ... />;
      // case 'glossary-item':
      //   return <GlossaryItemField ... />;
      
      default:
        // Fallback to text field for unknown types
        return (
          <TextField
            id={item.id}
            content={item.content}
            isActive={isActive}
            onUpdate={onUpdate}
            onDelete={onDelete}
            onFocus={onFocus}
            onEnter={onEnter}
            onBackspace={onBackspace}
            onArrowUp={onArrowUp}
            onArrowDown={onArrowDown}
            onCommand={onCommand}
            className={className}
          />
        );
    }
  };

  return renderContent();
}; 